import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementBarCounter(props) {
  const { editMode, index, showElementSettings } = props;

  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // dnd-kit styles for dragging
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // Calculations for the progress bar
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const now = getParamValue('progress', 50);
  const barColor = getParamValue('barBackgroundColor', '#48b0f7');
  const bgColor = getParamValue('progressBackgroundColor', '#dddddd');
  const textColor = getParamValue('textColor', '#fff');

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-bar-counter ${shownClass} ${cssClasses} ${responsiveClasses}`}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {/* Dynamic styles for animations/custom CSS */}
      {elementStyleTag}

      <span className="progress-title">{getParamValue('title', '')}</span>

      <div className="progress" style={{ backgroundColor: bgColor }}>
        <div
          className="progress-bar"
          style={{
            // The bar fills from 0 to "now" as soon as `shown` is true.
            width: (shown ? now : 0) + '%',
            backgroundColor: barColor,
            color: textColor,
            transition: 'width 1s ease-in-out',
          }}
        >
          {now + '%'}
        </div>
      </div>

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      {/* Stable wrapper for ScrollTrigger (React 19 fix) */}
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementBarCounter;
